export default __webpack_public_path__ + "static/media/about-img.36f3d583.png";